// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_d_v","cls2":"CiterightInline-cls2_lyn CiterightInline-cls1_d_v"};